import React, { useState } from 'react'

// Utils
import { getParsedItem, setStringifiedItem } from 'utils/localStorage'

// Constants
import localStorageKeys from 'constants/localStorageKeys'

// Components
import BannerCard from 'components/BannerCard'

// Styles
import { Wrapper } from './BannerCardList.styles'

import { BannerType } from '../BannerCardList/Banners'
// Types
interface BannerCardListProps {
  // Maximum number of banners to render
  maxBanners?: number
  // List of banners to render
  banners: BannerType[]
  // Render the smallest version of the BannerCard
  smallBanners?: boolean
  // All Banners cannot be dismissed
  nonDismissable?: boolean
}

/** Renders a given list of BannerCards */
const BannerCardList: React.FC<BannerCardListProps> = ({
  maxBanners = 2,
  banners,
  smallBanners,
  nonDismissable,
}) => {
  const [dismissedBannerCards, setDismissedBannerCards] = useState<string[]>(
    getParsedItem(localStorageKeys.dismissedBannerCards) ?? []
  )

  const handleDismiss = (dismissedBannerCard: string) => {
    if (!dismissedBannerCards.includes(dismissedBannerCard)) {
      const currentDismissedBannerCards = [
        dismissedBannerCard,
        ...dismissedBannerCards,
      ]

      // Set the current BannerCard ID to the list of dismissed banners
      setStringifiedItem(
        localStorageKeys.dismissedBannerCards,
        currentDismissedBannerCards
      )

      setDismissedBannerCards(currentDismissedBannerCards)
    }
  }

  const renderableBanners = banners.filter(
    banner => !dismissedBannerCards.includes(banner.id)
  )

  const croppedBanners = renderableBanners.slice(0, maxBanners)

  if (!croppedBanners.length) {
    return null
  }

  return (
    <Wrapper>
      {croppedBanners.map(
        ({ id, title, description, icon, action, isDismissable }) => (
          <BannerCard
            id={id}
            key={id}
            title={title}
            description={description}
            icon={icon}
            action={action}
            small={smallBanners}
            onDismiss={
              nonDismissable
                ? undefined
                : isDismissable
                ? handleDismiss
                : undefined
            }
          />
        )
      )}
    </Wrapper>
  )
}

export default BannerCardList
